/**
 * Validation du check digit ISO 3779 sur un VIN.
 *
 * Le 9e caractère est un check digit calculé sur les 16 autres.
 * Certains constructeurs européens ne le respectent pas strictement, donc
 * un échec doit être traité en warning, pas en blocage.
 *
 * Backend conserve la source de vérité à :
 *   packages/backend/src/utils/vinChecksum.ts
 */

const VIN_VALUES: Record<string, number> = {
  A: 1, B: 2, C: 3, D: 4, E: 5, F: 6, G: 7, H: 8,
  J: 1, K: 2, L: 3, M: 4, N: 5, P: 7, R: 9,
  S: 2, T: 3, U: 4, V: 5, W: 6, X: 7, Y: 8, Z: 9,
  '0': 0, '1': 1, '2': 2, '3': 3, '4': 4, '5': 5, '6': 6, '7': 7, '8': 8, '9': 9,
};

const VIN_WEIGHTS = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2];

const VIN_FORMAT_REGEX = /^[A-HJ-NPR-Z0-9]{17}$/;

export const isVinFormatValid = (vin: string): boolean => VIN_FORMAT_REGEX.test(vin);

export const validateVinCheckDigit = (vin: string): boolean => {
  if (!isVinFormatValid(vin)) return false;
  const sum = vin.split('').reduce(
    (acc, c, i) => acc + (VIN_VALUES[c] ?? 0) * VIN_WEIGHTS[i],
    0,
  );
  const check = sum % 11;
  const expected = vin[8];
  return check === 10 ? expected === 'X' : expected === String(check);
};
